import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from '../../../axios';
import './Contact.scss';
import customerService from '../../../img/customerService.svg';

const validationSchema = Yup.object({
    email: Yup.string().email('Nieprawidłowy adres e-mail').required('Adres e-mail jest wymagany'),
    title: Yup.string().max(100, 'Tytuł zapytania nie może mieć więcej niż 100 znaków').required('Tytuł zapytania jest wymagany'),
    message: Yup.string()
        .max(500, 'Treść zapytania nie może mieć więcej niż 500 znaków')
        .required('Treść zapytania jest wymagana'),
});

const initialValues = { name: '', surname: '', email: '', title: '', message: '' };

const Contact = () => {
    const [status, setStatus] = useState({ type: '', message: '' });

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        setSubmitting(true);
        setStatus({ type: '', message: '' });

        try {
            await Promise.all([axios.post('/message', values), axios.post('/sendEmail', values)]);
            setStatus({ type: 'success', message: 'Wiadomość została wysłana!' });
            resetForm();
        } catch (error) {
            console.error('Wystąpił błąd podczas wysyłania wiadomości:', error);
            setStatus({ type: 'error', message: 'Wystąpił błąd podczas wysyłania wiadomości.' });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <section className='Contact' id='Contact'>
            <div className='Contact_wrapper'>
                <div className='Contact_container'>
                    <div className='Contact_intro'>
                        <span className='Contact_kicker'>Wsparcie</span>
                        <h1 className='Contact_title'>Skontaktuj się z nami</h1>
                        <p className='Contact_lead'>
                            Masz pytania dotyczące Nekrodruku lub potrzebujesz pomocy przy wdrożeniu? Wyślij nam wiadomość, a wrócimy z odpowiedzią
                            maksymalnie w ciągu jednego dnia roboczego.
                        </p>
                        <div className='Contact_highlights'>
                            <div className='Contact_highlight'>
                                <img src={customerService} alt='' aria-hidden='true' />
                                <div>
                                    <h2>Wsparcie dedykowanego zespołu</h2>
                                    <p>Pomagamy dobrać rozwiązania, rozwiązać problemy techniczne i dzielimy się najlepszymi praktykami pracy z aplikacją.</p>
                                </div>
                            </div>
                            <a className='Contact_link' href='mailto:nekrodruk@gmail.com'>nekrodruk@gmail.com</a>
                        </div>
                    </div>

                    <div className='Contact_formCard'>
                        <h2>Formularz kontaktowy</h2>
                        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                            {({ isSubmitting }) => (
                                <Form className='Contact_form' noValidate>
                                    <div className='Contact_fieldGroup'>
                                        <label className='Contact_label' htmlFor='email'>
                                            Adres e-mail
                                        </label>
                                        <Field type='email' id='email' name='email' className='Contact_input' placeholder='np. kontakt@twojafirma.pl' />
                                        <ErrorMessage name='email' component='div' className='Contact_error' />
                                    </div>

                                    <div className='Contact_fieldGroup'>
                                        <label className='Contact_label' htmlFor='title'>
                                            Tytuł zapytania
                                        </label>
                                        <Field type='text' id='title' name='title' className='Contact_input' placeholder='Jak możemy pomóc?' />
                                        <ErrorMessage name='title' component='div' className='Contact_error' />
                                    </div>

                                    <div className='Contact_fieldGroup'>
                                        <label className='Contact_label' htmlFor='message'>
                                            Treść zapytania
                                        </label>
                                        <Field
                                            as='textarea'
                                            id='message'
                                            name='message'
                                            className='Contact_textarea'
                                            placeholder='Opisz krótko swoją sprawę...'
                                        />
                                        <ErrorMessage name='message' component='div' className='Contact_error' />
                                    </div>

                                    <div className='Contact_formFooter'>
                                        <button className='Contact_submit' type='submit' disabled={isSubmitting}>
                                            Wyślij wiadomość
                                        </button>
                                        <p className={`Contact_status ${status.type}`} role='status' aria-live='polite'>
                                            {status.message}
                                        </p>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;
